export default "__VITE_ASSET__9gU4Bzll__"